var map = {
	"./basanov.png": "8431",
	"./dachiev.png": "0076",
	"./domogakov.png": "a6ba",
	"./german.png": "ef18",
	"./ohlopkov.png": "cbc3",
	"./ohlopkov__header.png": "d97e",
	"./plotkin.png": "fa43",
	"./sultan.png": "f8bc"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "50fa";